import { MemoLoaPreview } from '@shared/models/memo.model';

export class ClearMemoDetail {
  static readonly type = '[PreApprove] Clear Memo Detail';
}

export class isSave {
  static readonly type = '[PreApprove] Is Save';
  constructor(public payload: string | null) {}
}

export class SetLoaData {
  static readonly type = '[PreApprove] Set Loa Data';
  constructor(public payload: MemoLoaPreview[]) {}
}

export class SetOnApprove {
  static readonly type = '[PreApprove] Set On Approve';
  constructor(public payload: any) {}
}

export class ResetOnApprove {
  static readonly type = '[PreApprove] Reset OnApprove';
}

export type ValidationFieldType = 'phone' | 'name' | 'lastName';

export class SetValidationError {
  static readonly type = '[PreApprove] Set Validation Error';
  constructor(
    public fieldType: ValidationFieldType,
    public payload: boolean,
  ) {}
}

export class GetVerificationAction {
  static readonly type = '[PreApprove] Get Verification Action';
  constructor(public id: number, public memoType: string) {}
}
